import { render } from "./button-group.vue?vue&type=template&id=22d7fd74&scoped=true"
const script = {}

import "./button-group.vue?vue&type=style&index=0&id=22d7fd74&scoped=true&lang=css"

import exportComponent from "/home/buildsseatshopcom/builds.seatshop.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d7fd74"]])

export default __exports__